import React from "react";
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  small?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  small = false,
  className = ""
}: CtaButtonProps) {
  return <a href={href} className={`cta${small ? " cta-small" : ""}${className ? ` ${className}` : ""}`} data-id="element-33" data-mp="hknbg8zjjdvk">
      {children}
    </a>;
}